var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'h-screen': _vm.hScreen},attrs:{"id":"app"}},[_c('v-app',[_c('nav-bar'),_c('div',[_c('error'),_c('div',[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }